import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ExpandableList from 'components/application/ExpandableList';
import InfoBanner from 'components/application/InfoBanner';

import DivisionItem from 'components/riskRegister/sharedResourceNotices/components/shared/DivisionItem';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function MultiDivisionCategoryNotice({ category, divisions }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'riskRegister.sharedResourceNotices.components.MultiDivisionCategoryNotice',
  });

  return (
    <InfoBanner title={i18nT('title')}>
      {i18nT('description', {
        categoryName: category.attributes.name,
        interpolation: { escapeValue: false },
      })}
      <ExpandableList
        collection={divisions}
        renderItem={(division) => (
          <li key={division.id}>
            <DivisionItem
              division={division}
              riskAssessment={null}
              scopedCategories={[]}
            />
          </li>
        )}
      />
    </InfoBanner>
  );
}

MultiDivisionCategoryNotice.propTypes = {
  category: resourceShape('trade').isRequired,
  divisions: PropTypes.arrayOf(resourceShape('company')).isRequired,
};
